import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Button } from '../../ui/button';

export function DefaultNotFoundPage(): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4 text-center">
      <h1 className="text-6xl font-bold">{t('errors.notFound.code')}</h1>
      <h2 className="text-2xl font-semibold">{t('errors.notFound.title')}</h2>
      <p className="text-muted-foreground">{t('errors.notFound.description')}</p>
      <Button asChild>
        <Link to="/">{t('errors.goHome')}</Link>
      </Button>
    </div>
  );
}
